export default __webpack_public_path__ + "static/media/designed-for-everyone.217f9c31.jpg";